import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            default: ""
        }
    },
    computed:{
        ...mapGetters({
            data:'data/getData',
            mode:'mode/getMode'
        })
    },
    methods: {
        ...mapActions({
            clearError:'error/clearError',
            addError:'error/addError',
            load:'data/load',
            toEditModel:'evaluate/toEditModel',
            exportXml:'evaluate/exportXml',
            shortSpinShow:'view/shortSpinShow',
            shortSpinHide:'view/shortSpinHide',
            searchLoad:'search/load',
        }),
        xmlload(selectedFile){
            this.shortSpinShow()
            this.clearError()
            // FileReaderの設定
            let reader = new FileReader()
            reader.onload = () => {
                // ファイルを文字列とオブジェクトで保持するための準備
                let fileString = reader.result
                let dataString = {}

                // 文字列をBFFにPOSTする
                this.toEditModel({fileString, mode:this.mode})
                    .then(response => {
                        dataString = response.data
                        Object.keys(dataString).forEach(function(key){
                        // 数値を文字列にしないとcheckedValueがエラーになる
                            if(typeof dataString[key] == 'number'){
                                dataString[key] = dataString[key].toString()
                            }
                        })
                        this.load(dataString)
                        this.searchLoad(dataString)
                    }, (err) => {
                        this.addError('XMLの読み込みに失敗しました。('+err.response.data.message+')')
                        scroll(0, 0)
                        this.shortSpinHide()
                    })
            }

            // 選択されたファイルを文字列形式で読み込む
            reader.readAsText(selectedFile)
            this.shortSpinHide()
        },
        xmlsave(input){
            this.shortSpinShow()
            this.clearError()
            this.exportXml(input)
                .then(response => {
                    let blob = new Blob([response.data.xmlContent], {type: 'application/xml'})
                    if(navigator.msSaveOrOpenBlob){
                        // IE対応(EdgeもmsSaveOrOpenBlobに対応しているためこちらで処理されます)
                        navigator.msSaveOrOpenBlob(blob, 'resume.xml')
                    } else {
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'resume.xml'
                        // 実在する要素(非表示でよい)の子要素としてa要素を追加しないとChrome以外で動かない
                        document.getElementById('invisible').appendChild(link)
                        link.click()
                        document.getElementById('invisible').removeChild(link)
                    }
                    this.shortSpinHide()
                }, () => {
                    this.addError('XMLの出力に失敗しました')
                    scroll(0, 0)
                    this.shortSpinHide()
                })
        },
    }
}